import React from "react";
import reception from "../assets/reception.jpg";
import OT from "../assets/OT.jpeg";
import Navbar from "../layout/Navbar";
import Footer from "../layout/Footer";
import { Link } from "react-router-dom";

const Overview = () => {
  return (
    <div className="min-h-screen flex flex-col bg-white text-gray-800">
      <Navbar />
      
      {/* Hero Section */}
      <div className="relative bg-gradient-to-r from-[#009DA5]/90 to-[#009DA5]/70 text-white">
        <div className="absolute inset-0 bg-black/50 mix-blend-multiply"></div>
        <div className="relative max-w-screen-xl mx-auto px-4 py-24 md:py-32">
          <h1 className="text-4xl md:text-5xl font-bold mb-4">Welcome to Trauma Centre IMS BHU</h1>
          <p className="text-lg md:text-xl max-w-2xl text-white/90">
            India's premier Level 1 trauma care facility providing exceptional emergency medical services to the people of Purvanchal and beyond.
          </p>
        </div>
      </div>

      <main className="flex-grow">
        {/* Stats Bar */}
        <div className="bg-gradient-to-r from-gray-100 to-white">
          <div className="max-w-screen-xl mx-auto px-4 py-6">
            <div className="grid grid-cols-2 md:grid-cols-4 gap-6 text-center">
              <div className="p-4">
                <p className="text-3xl font-bold text-[#009DA5]">354</p>
                <p className="text-sm text-gray-600">Beds</p>
              </div>
              <div className="p-4">
                <p className="text-3xl font-bold text-[#009DA5]">24/7</p>
                <p className="text-sm text-gray-600">Operational</p>
              </div>
              <div className="p-4">
                <p className="text-3xl font-bold text-[#009DA5]">12K+</p>
                <p className="text-sm text-gray-600">Annual Admissions</p>
              </div>
              <div className="p-4">
                <p className="text-3xl font-bold text-[#009DA5]">8.5K+</p>
                <p className="text-sm text-gray-600">Surgeries Per Year</p>
              </div>
            </div>
          </div>
        </div>

        {/* Main Content */}
        <div className="max-w-screen-xl mx-auto px-4 py-16 space-y-24">
          {/* About Section */}
          <section className="relative">
            <div className="absolute left-0 top-0 h-20 w-1 bg-[#009DA5]"></div>
            <div className="grid md:grid-cols-2 gap-12 items-center">
              <div className="md:order-1 pl-6">
                <h2 className="text-3xl md:text-4xl font-bold mb-6">
                  <span className="text-[#009DA5]">Trauma Centre</span> IMS BHU
                </h2>
                <p className="text-lg leading-relaxed text-gray-700">
                  The Trauma Centre at Banaras Hindu University in Varanasi serves as India's Level 1 referral Trauma Centre. With 354 beds, our facility operates 24/7 to provide comprehensive trauma care to patients from Uttar Pradesh, Bihar, Madhya Pradesh, and Chhattisgarh.
                </p>
                <p className="mt-4 text-lg leading-relaxed text-gray-700">
                  Before COVID, we served over 1.87 lakh patients annually through our indoor, outdoor, and diagnostic services. With approximately 12,000 admissions and 8,500 surgeries yearly, we've established ourselves as a cornerstone of advanced trauma care in India.
                </p>
                <div className="mt-8 flex flex-wrap gap-4">
                  {/* <button className="px-6 py-3 bg-[#009DA5] text-white font-medium rounded-lg hover:bg-[#00878e] transition-colors">
                    Our Services
                  </button> */}
                  <Link to="/contact-us">
                  <button className="px-6 py-3 border-2 border-[#009DA5] text-[#009DA5] font-medium rounded-lg hover:bg-[#009DA5]/10 transition-colors">
                    Contact Us
                  </button>
                  </Link>
                </div>
              </div>
              <div className="md:order-2">
                <div className="relative">
                  <div className="absolute -bottom-4 -right-4 w-full h-full border-2 border-[#009DA5] rounded-xl"></div>
                  <img
                    src={reception}
                    alt="Reception area of Trauma Centre IMS BHU"
                    className="w-full h-auto rounded-xl shadow-lg relative z-10"
                    loading="lazy"
                  />
                </div>
              </div>
            </div>
          </section>

          {/* Technology Section */}
          <section className="bg-gray-50 rounded-2xl p-8 md:p-12">
            <div className="grid md:grid-cols-2 gap-12 items-center">
              <div className="relative">
                <div className="absolute -top-4 -left-4 w-32 h-32 bg-[#009DA5]/10 rounded-full"></div>
                <img
                  src={OT}
                  alt="Advanced medical equipment at Trauma Centre IMS BHU"
                  className="w-full h-auto rounded-xl shadow-lg relative z-10"
                  loading="lazy"
                />
              </div>
              <div>
                <h2 className="text-3xl md:text-4xl font-bold mb-6">
                  Equipped with <span className="text-[#009DA5]">Latest Technology</span>
                </h2>
                <p className="text-lg leading-relaxed text-gray-700">
                  Our hospital integrates state-of-the-art medical technologies, merging innovation with compassionate care. From advanced diagnostics to modern surgical techniques, we aim to stay at the forefront of healthcare, ensuring patients receive the most effective treatment solutions.
                </p>
                <div className="mt-8 space-y-4">
                  <div className="flex items-center">
                    <div className="w-10 h-10 rounded-full bg-[#009DA5]/10 flex items-center justify-center mr-4">
                      <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-[#009DA5]" viewBox="0 0 20 20" fill="currentColor">
                        <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                      </svg>
                    </div>
                    <p className="text-gray-700">Advanced Diagnostic Equipment</p>
                  </div>
                  <div className="flex items-center">
                    <div className="w-10 h-10 rounded-full bg-[#009DA5]/10 flex items-center justify-center mr-4">
                      <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-[#009DA5]" viewBox="0 0 20 20" fill="currentColor">
                        <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                      </svg>
                    </div>
                    <p className="text-gray-700">Modern Surgical Facilities</p>
                  </div>
                  <div className="flex items-center">
                    <div className="w-10 h-10 rounded-full bg-[#009DA5]/10 flex items-center justify-center mr-4">
                      <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-[#009DA5]" viewBox="0 0 20 20" fill="currentColor">
                        <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                      </svg>
                    </div>
                    <p className="text-gray-700">Integrated Patient Care Systems</p>
                  </div>
                </div>
              </div>
            </div>
          </section>

          {/* Additional Features Section */}
          <section>
            <div className="text-center mb-12">
              <h2 className="text-3xl md:text-4xl font-bold mb-4">
                Why Choose <span className="text-[#009DA5]">Trauma Centre IMS BHU</span>
              </h2>
              <p className="text-lg text-gray-600 max-w-3xl mx-auto">
                We combine expert care with cutting-edge technology to provide the best possible outcomes for our patients
              </p>
            </div>
            <div className="grid md:grid-cols-3 gap-8">
              <div className="bg-white p-6 rounded-xl shadow-md hover:shadow-lg transition-shadow">
                <div className="w-14 h-14 bg-[#009DA5]/10 rounded-full flex items-center justify-center mb-4">
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-[#009DA5]" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
                  </svg>
                </div>
                <h3 className="text-xl font-bold mb-2">Expert Staff</h3>
                <p className="text-gray-600">
                  Our team consists of highly trained specialists dedicated to providing exceptional trauma care.
                </p>
              </div>
              <div className="bg-white p-6 rounded-xl shadow-md hover:shadow-lg transition-shadow">
                <div className="w-14 h-14 bg-[#009DA5]/10 rounded-full flex items-center justify-center mb-4">
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-[#009DA5]" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
                  </svg>
                </div>
                <h3 className="text-xl font-bold mb-2">Comprehensive Care</h3>
                <p className="text-gray-600">
                  From emergency response to rehabilitation, we provide complete care throughout the recovery journey.
                </p>
              </div>
              <div className="bg-white p-6 rounded-xl shadow-md hover:shadow-lg transition-shadow">
                <div className="w-14 h-14 bg-[#009DA5]/10 rounded-full flex items-center justify-center mb-4">
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-[#009DA5]" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2" />
                  </svg>
                </div>
                <h3 className="text-xl font-bold mb-2">Research & Education</h3>
                <p className="text-gray-600">
                  We continually advance trauma care through innovative research and education programs.
                </p>
              </div>
            </div>
          </section>
        </div>
      </main>
      
      <Footer />
    </div>
  );
};

export default Overview;